export default "__VITE_ASSET__BWG50ABn__"